<!-- =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/register.jpg" alt="register" class="mx-auto">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
              <div v-if="lang==='es'" class="px-8 pt-8 register-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4  class="mb-4">
                    Regístrate</h4>
                  <p>Complete su información para crear su cuenta.</p>
                </div>
                <vs-tabs>
                  <vs-tab label="Registro de correo electrónico">
                    <register-jwt></register-jwt>
                  </vs-tab>

<!--                  <vs-tab label="Inicio de sesión único" >-->
<!--                    <register-auth0></register-auth0>-->
<!--                  </vs-tab>-->
                </vs-tabs>
              </div>
              <div v-else class="px-8 pt-8 register-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4  class="mb-4">Signup</h4>
                  <p>Please complete your information to create your account.</p>
                </div>
                <vs-tabs>
                  <vs-tab label="Email Register">
                    <register-jwt></register-jwt>
                  </vs-tab>

                  <vs-tab label="Single Sign On">
                    <register-auth0></register-auth0>
                  </vs-tab>
                </vs-tabs>
              </div>

            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import RegisterJwt from './RegisterJWT.vue'
import RegisterAuth0 from './RegisterAuth0.vue'

export default {
  data () {
    return {
      lang:''
    }
},
  components: {
    RegisterJwt,
    RegisterAuth0
  },
  created(){
    this.lang = this.$route.params.lang;


  }

}
</script>

<style lang="scss">
  .register-tabs-container {
    min-height: 517px;

    .con-tab {
      padding-bottom: 23px;
    }
  }
</style>
